"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/interopRequireWildcard"));

var _layout = _interopRequireDefault(require("@/layout"));

/** When your routing table is too long, you can split it into small modules **/
var systemRouter = {
  type: 1,
  path: '/system-management',
  component: _layout.default,
  redirect: '/system-management/user-management',
  name: '',
  meta: {
    title: 'systemManagement',
    icon: 'settings'
  },
  children: [{
    type: 2,
    path: 'user-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/user-management'));
      });
    },
    name: 'user:view',
    meta: {
      title: 'userManagement'
    },
    children: [{
      path: 'add',
      name: 'user:add',
      hidden: true
    }, {
      path: 'update',
      name: 'user:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'user:delete',
      hidden: true
    }, {
      path: 'google:key',
      name: 'user:google:key',
      hidden: true
    }, {
      path: 'password:reset',
      name: 'user:password:reset',
      hidden: true
    }, {
      path: 'export',
      name: 'user:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'role-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/role-management'));
      });
    },
    name: 'role:view',
    meta: {
      title: 'roleManagement'
    },
    children: [{
      path: 'add',
      name: 'role:add',
      hidden: true
    }, {
      path: 'update',
      name: 'role:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'role:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'role:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'menu-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/menu-management'));
      });
    },
    name: 'menu:view',
    meta: {
      title: 'menuManagement'
    },
    children: [{
      path: 'add',
      name: 'menu:add',
      hidden: true
    }, {
      path: 'update',
      name: 'menu:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'menu:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'menu:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'department-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/department-management'));
      });
    },
    name: 'dept:view',
    meta: {
      title: 'departmentManagement'
    },
    children: [{
      path: 'add',
      name: 'dept:add',
      hidden: true
    }, {
      path: 'update',
      name: 'dept:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'dept:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'dept:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'dictionary-category',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/dictionary-category'));
      });
    },
    name: 'codeSort:view',
    meta: {
      title: 'dictionaryCategory'
    },
    children: [{
      path: 'add',
      name: 'codeSort:add',
      hidden: true
    }, {
      path: 'delete',
      name: 'codeSort:delete',
      hidden: true
    }, {
      path: 'update',
      name: 'codeSort:update',
      hidden: true
    }, {
      path: 'export',
      name: 'codeSort:export',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'dictionary-management',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/dictionary-management'));
      });
    },
    name: 'code:view',
    meta: {
      title: 'dictionaryManagement'
    },
    children: [{
      path: 'add',
      name: 'code:add',
      hidden: true
    }, {
      path: 'update',
      name: 'code:update',
      hidden: true
    }, {
      path: 'delete',
      name: 'code:delete',
      hidden: true
    }, {
      path: 'export',
      name: 'code:export',
      hidden: true
    }, {
      path: 'loadReapplication',
      name: 'code:loadReapplication',
      hidden: true
    }, {
      path: 'serverLoadConfigCache',
      name: 'code:serverLoadConfigCache',
      hidden: true
    }]
  }, {
    type: 2,
    path: 'login-black-list',
    component: function component() {
      return Promise.resolve().then(function () {
        return (0, _interopRequireWildcard2.default)(require('@/views/sms-system-management/login-black-list'));
      });
    },
    name: 'loginBlackList:view',
    meta: {
      title: 'loginBlackList'
    },
    children: [{
      path: 'add',
      name: 'loginBlackList:add',
      hidden: true
    }, {
      path: 'delete',
      name: 'loginBlackList:delete',
      hidden: true
    }]
  }]
};
var _default = systemRouter;
exports.default = _default;